module.exports = __webpack_public_path__ + "img/Vector.6ce03195.svg";